'use strict';

var destroy = require('./plugin/destroy');
var initialize = require('./plugin/initialize');
var update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};



//////////////////
// WEBPACK FOOTER
// G:/gitlab-runner/builds/fyb93P4s/0/kpmg/novacci.kpmg.cz/~/perfect-scrollbar/src/js/main.js
// module id = 98
// module chunks = 0